import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Registra a una pareja para el torneo.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "El capitán es quien mete los resultados de la pareja.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Registra a un equipo para el torneo.", -1)

import { ref, computed, onMounted, watch } from "vue";
import { registrarEquipo } from "@/services/InscripcionesService";
import { getUsuariosNoInscritosTorneoAsync } from "@/services/UsuariosService";
import {
  InscripcionEquipoDTO,
  TorneoEquipoGestionInfoDTO,
} from "@/interfaces/Inscripcion";
import { UsuarioSinEquipoDTO } from "@/interfaces/Usuario";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAddEquipo',
  props: {
    isVisible: { type: Boolean },
    torneo: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const teamName = ref("");
const jugadorSelected = ref<(UsuarioSinEquipoDTO | null)[]>([]);
const capitanSelected = ref<UsuarioSinEquipoDTO | null>(null);
const jugadores = ref<UsuarioSinEquipoDTO[]>([]);
const selectedPlayers = ref<UsuarioSinEquipoDTO[]>([]);
const idsSelected = ref<number[]>([]);
const isRegistering = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const snackBarShow = ref<boolean>(false);
const snackBarMessage = ref<string>("");
const snackBarTimeOut = ref<number>(3000);

const maxPlayers = computed(() => {
  return props.torneo.torneo.jugadoresXEquipo;
});

const esParejas = computed(() => props.torneo.torneo.tipoTorneo === "Parejas");

const dialogVisible = computed({
  get: () => props.isVisible,
  set: (value) => emit("close", value),
});

watch(dialogVisible, (visible) => {
  if (visible) {
    jugadorSelected.value = Array(maxPlayers.value - 1).fill(null);
  }
});

const getJugadoresDisponibles = (index: number) => {
  const idsSeleccionados = jugadorSelected.value
    .filter((_, i) => i !== index) // excluye el actual
    .filter((j) => j !== null)
    .map((j) => (j as UsuarioSinEquipoDTO).idUsuario);

  return jugadores.value.filter((j) => !idsSeleccionados.includes(j.idUsuario));
};

const validateForm = () => {
  // Comprueba nombre equipo
  if (!teamName.value.trim()) {
    snackBarMessage.value = esParejas.value
      ? "El nombre de la pareja es obligatorio"
      : "El nombre del equipo es obligatorio";
    snackBarShow.value = true;
    return false;
  }

  // Comprueba capitan
  if (!capitanSelected.value) {
    snackBarMessage.value = "Tienes que selecionar un capitán";
    snackBarShow.value = true;
    return false;
  }

  // Comprueba duplicado de capitan
  for (const jugador of jugadorSelected.value) {
    if (jugador?.idUsuario == capitanSelected.value.idUsuario) {
      snackBarMessage.value =
        "El capitán no puede estar repetido entre los jugadores.";
      snackBarShow.value = true;
      return false;
    }
  }

  idsSelected.value = [];
  const ids = new Set<number>();

  for (const jugador of jugadorSelected.value) {
    if (!jugador) continue;

    if (ids.has(jugador.idUsuario)) {
      snackBarMessage.value = "No se pueden duplicar los jugadores";
      snackBarShow.value = true;
      return false;
    }

    ids.add(jugador.idUsuario);
  }

  idsSelected.value = [...ids];

  return true;
};

const submitForm = async () => {
  if (
    props.torneo.torneo.idTorneo &&
    capitanSelected.value &&
    jugadorSelected.value.length > 1
  ) {
    if (!validateForm()) return;
    const inscripcionEquipo: InscripcionEquipoDTO = {
      idTorneo: props.torneo.torneo.idTorneo,
      idCapitan: capitanSelected.value.idUsuario,
      nombreEquipo: teamName.value,
      miembros: idsSelected.value,
      idUsuario: 0,
      idEquipo: 0,
      idOrganizador: 0,
      emailOrganizador: "",
      componentesEquipoDTO: [],
      idInscripcion: 0,
    };
    try {
      isRegistering.value = true;
      await registrarEquipo(inscripcionEquipo);
      showSuccessModal.value = true;
      emit("confirm");
    } catch (error) {
      showErrorModal.value = true;
    } finally {
      isRegistering.value = false;
      teamName.value = "";
      selectedPlayers.value = [];
      idsSelected.value = [];
    }
  } else {
    showErrorModal.value = true;
  }
};

const closeDialog = () => {
  emit("close");
  teamName.value = "";
  selectedPlayers.value = [];
  idsSelected.value = [];
};

onMounted(async () => {
  if (props.torneo.torneo.idTorneo == undefined) return;
  try {
    const responseJugadores = await getUsuariosNoInscritosTorneoAsync(
      props.torneo.torneo.idTorneo
    );
    jugadores.value = (responseJugadores?.data ?? []).sort(
      (a: { nick: string }, b: { nick: string }) => a.nick.localeCompare(b.nick)
    );
  } catch (error) {
    console.error("Error al obtener jugadores: ", error);
    jugadores.value = [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_ModalSuccess = _resolveComponent("ModalSuccess")!
  const _component_ModalError = _resolveComponent("ModalError")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(esParejas.value ? "Registrar pareja" : "Registrar Equipo"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (esParejas.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_1,
                      _hoisted_2
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_3,
                      _createElementVNode("p", null, "Debes añadir un máximo de " + _toDisplayString(maxPlayers.value) + " jugadores.", 1)
                    ], 64)),
                _createVNode(_component_v_text_field, {
                  modelValue: teamName.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((teamName).value = $event)),
                  label: esParejas.value ? 'Nombre de la pareja' : 'Nombre del equipo',
                  tonal: "",
                  required: ""
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_combobox, {
                      modelValue: capitanSelected.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((capitanSelected).value = $event)),
                      items: jugadores.value,
                      "item-title": "nick",
                      "item-value": "idUsuario",
                      label: "Selecciona el capitán",
                      tonal: "",
                      required: "",
                      "return-object": true
                    }, null, 8, ["modelValue", "items"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxPlayers.value - 1, (index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createVNode(_component_v_combobox, {
                          modelValue: jugadorSelected.value[index],
                          "onUpdate:modelValue": ($event: any) => ((jugadorSelected.value[index]) = $event),
                          items: getJugadoresDisponibles(index),
                          "item-title": "nick",
                          "item-value": "idUsuario",
                          label: esParejas.value ? 'Selecciona al compañero' : 'Selecciona a un jugador',
                          tonal: "",
                          required: "",
                          "return-object": true
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "primary",
                  onClick: submitForm,
                  disabled: isRegistering.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(esParejas.value ? "Registrar pareja" : "Registrar equipo"), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "secondary",
                  onClick: closeDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cerrar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: esParejas.value ? 'Pareja registrada con éxito.' : 'Equipo registrado con éxito.',
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(_component_ModalError, {
      isVisible: showErrorModal.value,
      message: `No se ha podido registrar ${esParejas.value ? 'la pareja' : 'el equipo'}. Contacta con el administrador.`,
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(_component_v_dialog, {
      modelValue: isRegistering.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isRegistering).value = $event)),
      persistent: "",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, {
              class: "d-flex justify-center align-center",
              style: {"height":"150px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "blue-lighten-3",
                  size: 57
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      color: "red-darken-2",
      timeout: snackBarTimeOut.value,
      modelValue: snackBarShow.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((snackBarShow).value = $event)),
      eager: "",
      "auto-height": ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackBarMessage.value), 1)
      ]),
      _: 1
    }, 8, ["timeout", "modelValue"])
  ], 64))
}
}

})